var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojioneV1FlagForSouthAfrica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5408_45008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01897e-05 13.875V16.125C4.01897e-05 16.5784 0.0525402 17.0134 0.15229 17.4214L5.91079 13.875H4.01897e-05ZM0.136915 6.63337C0.0443647 7.04072 -0.00155541 7.45727 4.01897e-05 7.875V10.125H5.64304L0.136915 6.63337ZM24 10.125V7.875C24 5.59688 22.7352 3.75 20.25 3.75H3.75004C3.40204 3.75 3.08104 3.78938 2.78104 3.858L12.75 10.125H24Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 9.375L4.399 3.75H3.75025C3.40225 3.75 3.08125 3.78938 2.78125 3.858L12.7502 10.125H24.0002V9.375H13.1252Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81934 20.1514C3.10809 20.2144 3.41709 20.25 3.75009 20.25H20.2501C22.7352 20.25 24.0001 18.4031 24.0001 16.125V13.875H12.7501L2.81934 20.1514Z",
    fill: "#2B3990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44346 20.25L13.1251 14.625H24.0001V13.875H12.7501L2.81934 20.1514C3.10809 20.2144 3.41709 20.25 3.75009 20.25H4.44346Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62484 13.872L5.61097 13.8701L0.152094 17.4206C0.486594 18.7883 1.37947 19.8383 2.81872 20.151L12.7498 13.875H23.9998V10.125H12.7498L2.78084 3.858C1.34497 4.18575 0.458094 5.25113 0.136719 6.63338L5.64284 10.125H5.62484L8.24984 12",
    fill: "#29B473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.137663 6.6315C0.0446545 7.03942 -0.00151898 7.45662 3.81003e-05 7.875V16.125C3.81003e-05 16.5701 0.0499131 16.9973 0.145913 17.3985L8.62504 12L0.137663 6.6315Z",
    fill: "#25333A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.137938 6.6315C0.0565625 6.981 0.0171875 7.35263 0.0078125 7.73513L6.75031 12L0.0096875 16.2915C0.0205625 16.6755 0.0625625 17.049 0.145813 17.3985L8.62531 12L0.137938 6.6315Z",
    fill: "#DBAD2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5408_45008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForSouthAfrica);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-south-africa.375680cb47f438eed488432f30178414.svg";
export { ForwardRef as ReactComponent };